import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import cx from 'classnames'
import Styles from './ExternalIntegrationSelect.module.scss'
import { PlatformIcon } from 'screens/ScheduledPosts/PlatformIcon'
import Silhouette from 'components/Previews/InstagramPreview/silhouette.jpg'
import { useState } from 'react'

interface AvatarWithPlatformIconProps {
  size?: 'sm' | 'md' | 'xs'
  avatar: string
  platform: ExternalIntegrationEnum
  hideIcon?: boolean
}

export const AvatarWithPlatformIcon = ({
  size = 'sm',
  avatar,
  platform,
  hideIcon = false,
}: AvatarWithPlatformIconProps) => {
  const [imageDidError, setImageDidError] = useState(false)
  const src = imageDidError ? Silhouette : avatar || Silhouette

  return (
    <div className={cx(Styles.avatarWithPlatformIcon, Styles[size])}>
      <img src={src} alt={platform} className={Styles.avatar} onError={() => setImageDidError(true)} />
      {!hideIcon && (
        <div className={cx(Styles.platformIcon, Styles[platform])}>
          <PlatformIcon platform={platform} size={12} isSelected />
        </div>
      )}
    </div>
  )
}
